var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",class:_vm.avatarClass,style:({ width: _vm.sizeUnit, height: _vm.sizeUnit }),on:{"click":function($event){$event.stopPropagation();return _vm.child($event)}}},[(_vm.status)?_c('span',{staticClass:"status",class:_vm.getClassByStatus(_vm.currentState),style:({
      width: _vm.statusSize,
      height: _vm.statusSize,
      border: (_vm.borderSize + " solid #fff")
    })}):_vm._e(),_c('img',{attrs:{"src":_vm.imgSrc},on:{"error":_vm.imgError}})])}
var staticRenderFns = []

export { render, staticRenderFns }